import { createContext, useContext, useState } from 'react';
import { useFormContext } from 'react-hook-form';

export const GridCornerContext = createContext(null);

export const useGridCorner = () => {
	return useContext(GridCornerContext);
};

export default function GridCornerProvider(props) {
	const [data, setData] = useState([]);
	const { getValues } = useFormContext();

	const getZvbFormat = () => {
		const result = { coordinatesX1: null, coordinatesY1: null, coordinatesX2: null, coordinatesY2: null, coordinatesX3: null, coordinatesY3: null, coordinatesX4: null, coordinatesY4: null, imageIndexId: getValues('id') };
		for (let i = 0; i < data.length; i += 1) {
			result[`coordinatesX${i + 1}`] = Math.round(data[i].x);
			result[`coordinatesY${i + 1}`] = Math.round(data[i].y);
		}
		console.log(result);
		return result;
	};

	const value = { data, setData, getZvbFormat };
	return <GridCornerContext.Provider value={value}>{props.children}</GridCornerContext.Provider>;
}
